import { getCellWidth } from "src/generator/utils/getCellWidth";

import useCellProps from "../../../../generator/PortraitOrientation/Row/useCellProps";
import { useTheme } from "../../../../hooks";
import { type ICol } from "../../../../interfaces";
import { useSelector } from "../../../../redux/hooks";

import ValueRenderer from "./ValueRenderer";
interface Props {
  col: ICol;
  index: number;
  isOverlay?: boolean;
  isDraftEntry?: boolean;
  history?: boolean;
  rowIndex?: number;
  lbeid?: string;
  entryIndex?: number;
  span?: number;
  pdfEntry?: boolean;
  layout?: number[];
}
const RowCell = ({
  col,
  index,
  isOverlay,
  isDraftEntry,
  history,
  rowIndex,
  lbeid,
  entryIndex,
  span,
  pdfEntry,
  layout,
}: Props) => {
  const theme = useTheme() as any;
  const { isDarkMode } = useSelector(state => state.preferencesSlice);
  const { shipType } = useSelector(state => state.generatorSlice);
  const type = useSelector(
    state => state.entriesGeneratorSlice.reportDetails?.type,
  );
  const { hiddenStyles } = useCellProps(Boolean(isOverlay));
  const colSpan =
    col && span ? span : col.colspan ? col.colspan : !col.full ? 1 : 999;
  const shouldBeGrayed =
    (shipType === "1" && (col as any).class === "grp-pass") || col.grayed;

  if (col.unit === "space" || col.type === "space" || col.hidden) {
    return (
      <td
        className="border-none"
        style={{ backgroundColor: theme.colors.background[0], border: "none" }}
      />
    );
  }
  return (
    <td
      id={col.id}
      colSpan={colSpan}
      rowSpan={col.rowspan ?? 1}
      key={index}
      style={{
        border: `1px solid ${
          history && col.unit !== "steering.pumps"
            ? isDarkMode
              ? "#31383f"
              : "rgb(190, 190, 190)"
            : theme.colors.main[9]
        }`,
        ...(history && { borderBottom: "none" }),
        textAlign: col.align ?? "center",
        ...(type !== 3 && {
          padding: col.unit === "check" ? "6px" : "8px",
        }),
        position: "relative",
        opacity: (history ?? isDraftEntry) ? 0.2 : 1,
        backgroundColor: shouldBeGrayed ? theme.colors.grayscale[2] : "",
        ...(col.background === "dimmed" && {
          backgroundColor: theme.colors.tdBackgroundColor[1],
        }),
        textDecoration:
          history && col.unit !== "steering.pumps" ? "line-through" : "none",
        ...((col.unit === "large/text" || col.unit === "text") && {
          maxWidth: "400px",
        }),
        ...hiddenStyles,
        width: layout
          ? undefined
          : col.explicitWidth
            ? getCellWidth(col.width)
            : "auto",
      }}>
      <div
        style={{
          minHeight: "22px",
          display: "flex",
          justifyContent:
            (col.align ?? col.list)
              ? "flex-start"
              : col.suffix && !col.value
                ? "flex-end"
                : col.unit === "BLANK"
                  ? "flex-start"
                  : col.unit === "check"
                    ? "center"
                    : "flex-start", // align to left same as entry
          alignItems: "center",
          opacity: col.suffix && !col.value && !col.list ? 0.6 : 1,
          color: col.changed
            ? col.changedType === "edit"
              ? "red"
              : "green"
            : "auto",
          ...hiddenStyles,
          ...(col.minHeight && { minHeight: col.minHeight, height: "auto" }),
          ...((col.unit === "large/text" || col.unit === "text") && {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }),
        }}>
        <ValueRenderer
          col={col}
          rowIndex={rowIndex}
          lbeid={lbeid}
          entryIndex={entryIndex}
          pdfEntry={pdfEntry}
        />
      </div>
      {history && col.unit === "check" && (
        <div
          style={{
            position: "absolute",
            height: "0.5px",
            width: "24px",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            background: "black",
          }}
        />
      )}
    </td>
  );
};
export default RowCell;
